import dxpDigitalDataAssignment from '../../../../../common/utilities/dxpDigitalDataAssignment';
import { DxpDataLayerType } from '../../../../../common/utilities/customDatalayerInterface';
import dxpDataLayerToggleVerification from '../../../../../common/utilities/dxpDataLayerToggleVerification';

const useNewDxpDigitalAssignmentEntryEvent = () => {
  const callDxpDigitalAssignmentEntryEvent = (customData?: Partial<DxpDataLayerType>, jlrDataLayer = false) => {
    const isDxpDataLayerEnabled = dxpDataLayerToggleVerification();

    if (isDxpDataLayerEnabled && jlrDataLayer) {
      try {
        dxpDigitalDataAssignment(
          {
            ...customData,
          },
          jlrDataLayer,
        );
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('DataLayer error', err);
      }
    }
  };

  return { callDxpDigitalAssignmentEntryEvent };
};

export default useNewDxpDigitalAssignmentEntryEvent;
